// 局內 boon（roguelite run buffs）。純模擬層（無框架依賴 → 1:1 可移植到 Django）。
// 玩家每次擊殺後彈三選一，套用到該局玩家 entity，結算清空（run-scoped）。
import { type Boon, boonById, PACK_BOONS } from './JKGame_pack'
import { JKGameRng } from './JKGame_rng'
import type { Entity } from './JKGame_types'

// Deterministic three-choice offer. Uses an INDEPENDENT RNG stream seeded from (match seed,
// kill index) — NOT the live match rng — so:
//   1. it never advances the shared stream (same-seed replay stays byte-identical), and
//   2. the same (seed, kills) always yields the same three cards (reroll-proof: a player can't
//      re-open the offer for different options).
// Picks up to 3 DISTINCT boons; with a ≥3 pool (enforced by the pack schema) it always returns 3.
export function rollBoonChoices(seed: number, kills: number): string[] {
  const rng = new JKGameRng(seed * 100003 + kills)
  const pool = PACK_BOONS.map((b) => b.id)
  rng.shuffle(pool)
  return pool.slice(0, 3)
}

// Apply a boon to an entity (additive). mhp/msp also raise the CURRENT pool by the same amount
// so the buff is felt right away (a +mhp that didn't heal would feel inert mid-fight).
export function applyBoon(entity: Entity, boonId: string): boolean {
  const boon: Boon | undefined = boonById(boonId)
  if (!boon) return false
  switch (boon.stat) {
    case 'mhp':
      entity.mhp += boon.amount
      entity.hp += boon.amount
      break
    case 'msp':
      entity.msp += boon.amount
      entity.sp += boon.amount
      break
    default:
      entity[boon.stat] += boon.amount
  }
  return true
}
